export interface Carrier {
    scac: string;
    name: string;
    is_terminal49_enabled: boolean;
    is_project44_enabled: boolean;
}
